import { observer } from "mobx-react";
import { default as React, useContext, useEffect } from "react";
import { Alert, Col, Container, Row } from "react-bootstrap";
import { CountdownCircleTimer } from "react-countdown-circle-timer";
import { RootStoreContext } from "../../stores/RootStore";
import successMp3 from "../../audio/Success.mp3";
import { formatToTimezone } from "src/util";

const RegistrationSuccessStep = observer(() => {
  const {
    registrationStore: { selectedItems, restart, restartAfterEventTicketPurchase, restartAfterRentalBooking, selectedTickets, selectedRentals, user, hasOnlyTicketsPurchased, hasOnlyRentalsBooked },
    suggestionStore,
  } = useContext(RootStoreContext);

  useEffect(() => {
    const successAudio = new Audio(successMp3);
    successAudio.play();
  });

  // Trigger 1: after a successful manual class check-in, surface the
  // early check-in suggestion dialog. Skipped for ticket-only / rental-only
  // purchases and (via cameFromDialog) when the success came from the dialog.
  const handleCountdownComplete = () => {
    if (hasOnlyTicketsPurchased) {
      restartAfterEventTicketPurchase();
      return;
    }
    if (hasOnlyRentalsBooked) {
      restartAfterRentalBooking();
      return;
    }
    restart();
    if (user?.id) {
      suggestionStore.maybeShowAfterCheckin(user.id);
    }
  };

  return (
    <Container>
      <Row>
        <Col
          lg={{ span: 4, offset: 4 }}
          md={{ span: 6, offset: 3 }}
          className="phone"
        >
          <Alert variant="success">
            Successfully booked: <br />
            <ul>
              {selectedItems.map((item) => (
                <li key={item.trainingPeriodId}>
                  {item.title}
                  <br />
                </li>
              ))}
              {selectedTickets.map((ticket) => (
                <li key={ticket.eventId}>
                  {ticket.ticketName}
                  <br />
                </li>
              ))}
              {selectedRentals.map((rental, index) => {
                 // Format times in Estonian (Tallinn) timezone
                const startTimeStr = formatToTimezone(
                  rental.startTime,
                  'Europe/Tallinn',
                  'en-US',
                  { hour: '2-digit', minute: '2-digit', hour12: false }
                );
                const endTimeStr = formatToTimezone(
                  rental.endTime,
                  'Europe/Tallinn',
                  'en-US',
                  { hour: '2-digit', minute: '2-digit', hour12: false }
                );
                const timeStr = `${startTimeStr} - ${endTimeStr}`;

                return (
                  <li key={`rental-${index}`}>
                    {rental.rentalName} - {rental.locationName}
                    <br />
                    {rental.venueName}{rental.venueAddress && `, ${rental.venueAddress}`}
                    <br />
                    {rental.date} • {timeStr}
                    <br />
                  </li>
                );
              })}
            </ul>
            <br />
            Remaining coins: {user.latestTrainingPackage.availableCoins}
            <br />
            Have a great dance! 🕺💃
          </Alert>
        </Col>
      </Row>
      <Row>
        <Col className="phone" style={{ left: "50%", marginLeft: "-50px" }}>
          <CountdownCircleTimer
            isPlaying
            size={100}
            strokeWidth={8}
            duration={5}
            colors={"#013220"}
            onComplete={handleCountdownComplete}
          >
            {({ remainingTime }) => (
              <div className="countdown">{remainingTime}</div>
            )}
          </CountdownCircleTimer>
        </Col>
      </Row>
    </Container>
  );
});

export default RegistrationSuccessStep;
